import {sortBy} from 'lodash';

export const getHelixSnapshotSlice = (state) => state.helixSnapshot;

export const getHelixDocumentIdsByBodyId = (state, bodyId) => {
	const helixSnapshotsSlice = getHelixSnapshotSlice(state);
	return helixSnapshotsSlice && helixSnapshotsSlice[bodyId]?.helixDocuments?.allIds;
};

export function getHelixSnapshotsList(state, bodyId) {
	const helixDocuments = getHelixSnapshotSlice(state);
	const bodyHelixDocuments = helixDocuments && helixDocuments[bodyId]?.helixDocuments;
	const documentIdList = getHelixDocumentIdsByBodyId(state, bodyId);
	return documentIdList?.map((docId) => bodyHelixDocuments.byId && bodyHelixDocuments.byId[docId]);
}

export const getHelixDocumentById = (state, bodyId, documentId) => {
	if (documentId) {
		return getHelixSnapshotSlice(state)[bodyId].helixDocuments.byId[documentId];
	}
};

export const getHelixDocumentAnnotationIdsByDocumentId = (state, bodyId, documentId) => {
	return getHelixDocumentById(state, bodyId, documentId)?.annotations;
};

export const getHelixDocumentAnnotationById = (state, bodyId, annotationId) => {
	return getHelixSnapshotSlice(state)[bodyId].annotations.byId[annotationId];
};

export const getAnnotationsByDocumentId = (state, bodyId, documentId) => {
	return getHelixSnapshotSlice(state)[bodyId].helixDocuments.byId[documentId].annotations.map((annotationId) => {
		return getHelixDocumentAnnotationById(state, bodyId, annotationId);
	});
};

export const getHelixDocumentAnnotationIdsSortedByReference = (state, bodyId, documentId) => {
	return sortBy([...getAnnotationsByDocumentId(state, bodyId, documentId)], (a) => {
		return a.data.referenceNumber;
	}).map((a) => a.id);
};

export function getBoundingBoxVisibilityByBodyId(state, bodyId) {
	const snapshotsSlice = getHelixSnapshotSlice(state);

	const value = snapshotsSlice[bodyId]?.showBoundingBoxes;
	return value === undefined ? true : value;
}
